import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { UsuarioAuthDataService } from '../services/usuario-auth-data.service';

export const homeRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const usuarioAuthDataService = inject(UsuarioAuthDataService);

  const user = usuarioAuthDataService.usuarioAuth();
  const role = String(user?.rol?.nombre ?? '').toUpperCase().trim();
  const token = localStorage.getItem('auth_token');

  if (!user || !token) {
    return router.parseUrl('/login');
  }

  if (role === 'ROLE_ADMIN') {
    return router.parseUrl('/admin');
  }

  if (role === 'ROLE_MASTER_VALIDATOR') {
    return router.parseUrl('/contracts');
  }

  return router.parseUrl('/category');
};
